import { memo } from 'react';

import { OnOffShareToggleRow } from '~/components/ShareModal/components/OnOffShareToggleRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/**
 * "Fade into page" toggle (`presentationSettings.coverFade` — live-saved in edit mode, preview-only
 * in create mode), bound to the design context.
 */
export const CreateShowcaseDesignFadeRow = memo(() => {
  const { coverFade, handleToggleCoverFade, isLoading, coverSrc } = useCreateShowcaseDesign();

  // Fade blends the cover's bottom edge into the page background, so without a cover image it has
  // nothing to act on — same `coverSrc` gate the mini preview uses to render the cover band at all.
  const hasCoverImage = !!coverSrc;

  // The plan half of the old `layoutDisabled` gate is gone — the whole cover feature (image, width,
  // fade) is available on every plan — leaving the two honest reasons to disable: nothing to fade
  // without a cover, and nothing to preview into while the modal is still booting.
  const disabled = isLoading || !hasCoverImage;

  return (
    <OnOffShareToggleRow
      checked={coverFade}
      data-testid="CREATE_COLLECTION_LINK_DESIGN_FADE_ROW"
      disabled={disabled}
      label="Fade into page"
      onToggle={handleToggleCoverFade}
    />
  );
});

CreateShowcaseDesignFadeRow.displayName = 'CreateShowcaseDesignFadeRow';
